<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    id="Layer_1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    style="enable-background: new 0 0 24 24"
    xml:space="preserve">
    <g>
      <circle
        fill="none"
        stroke-width="2"
        stroke-miterlimit="10"
        cx="12"
        cy="12"
        r="11"
        stroke-linejoin="miter" />
      <line
        fill="none"
        stroke-width="2"
        stroke-linecap="square"
        stroke-miterlimit="10"
        x1="12"
        y1="17"
        x2="12"
        y2="11"
        stroke-linejoin="miter" />
      <line
        fill="none"
        stroke-width="2"
        stroke-linecap="square"
        stroke-miterlimit="10"
        x1="12"
        y1="8"
        x2="12"
        y2="7"
        stroke-linejoin="miter" />
    </g>
  </svg>
</template>
